import { Check } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../ui/dropdown-menu';

const PortalSelectorDropdown = ({ isDropdownOpen, setIsDropdownOpen, hasAdminAccess }) => {
    return (
        <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
            <DropdownMenuTrigger asChild>
                <button className="p-1 rounded-md hover:bg-neutral-200 focus:outline-hidden">
                    <div className="w-6 h-6 p-1 fill-neutral-950">
                        <img
                            src="/selector.svg"
                            alt="selector"
                            className="w-full h-full fill-neutral-500 group-hover:fill-primary"
                        />
                    </div>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className="absolute -right-62 -top-14 w-64 shadow-lg z-50 bg-neutral-50 border-neutral-300"
                align="end"
                side="right"
            >
                <DropdownMenuItem className="flex items-start gap-3 p-3">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full shrink-0">
                        <img
                            src="/Zindua-Alt-Favicon.png"
                            alt="Zindua LMS favicon"
                            className="w-10 h-10"
                        />
                    </div>
                    <div className="flex flex-col flex-1">
                        <div className="flex items-center justify-between">
                            <span className="font-medium text-neutral-950">Learning Portal</span>
                            <Check className="w-5 h-5 text-success" />
                        </div>
                        <span className="text-xs text-neutral-700">
                            {typeof window !== 'undefined'
                                ? window.location.host
                                : 'alpha.zinduaschool.com'}
                        </span>
                    </div>
                </DropdownMenuItem>
                {hasAdminAccess && (
                    <DropdownMenuItem
                        onClick={() => window.open('https://dash.zinduaschool.com', '_blank')}
                        className="flex items-start gap-3 p-3"
                    >
                        <div className="flex items-center justify-center w-10 h-10 rounded-full shrink-0">
                            <img
                                src="/Zindua-Alt-Favicon.png"
                                alt="Zindua LMS favicon"
                                className="w-10 h-10"
                            />
                        </div>
                        <div className="flex flex-col flex-1">
                            <span className="font-medium text-neutral-950">Admin/TM Dashboard</span>
                            <span className="text-xs text-neutral-700">dash.zinduaschool.com</span>
                        </div>
                    </DropdownMenuItem>
                )}
                <DropdownMenuItem
                    disabled
                    className="flex items-start gap-3 p-3 opacity-50 cursor-not-allowed"
                >
                    <div className="flex items-center justify-center w-10 h-10 rounded-full shrink-0">
                        <img
                            src="/Zindua-Alt-Favicon.png"
                            alt="Zindua LMS favicon"
                            className="w-10 h-10"
                        />
                    </div>
                    <div className="flex flex-col flex-1">
                        <span className="font-medium text-neutral-950">Alumni Portal</span>
                        <span className="text-xs text-neutral-700">
                            <p className="text-xs">alumni.zinduaschool.com</p>
                            <p className="text-xs">(In Development)</p>
                        </span>
                    </div>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default PortalSelectorDropdown;
